<div class="dash-content">
  <div class="grid">
    <!-- ─── KPI CARDS ─────────────────────────────────────────── -->
    <div class="col-12">
      <div class="dash-header">
        <div>
          <div class="dash-title">TarjetaKpi</div>
          <div class="dash-sub">5 variantes de color. Cada tarjeta incluye un sparkline en vivo.</div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="flex flex-wrap gap-3">
        @for (kpi of kpis; track $index) {
          <app-tarjeta-kpi [data]="kpi" class="flex-1" style="min-width:180px"/>
        }
      </div>
    </div>

<!--     ───── TARJETA KPI COMPARISON ────────────────────────────  -->
        <div class="col-12">
          <div class="dash-header">
            <div>
              <h2 class="dash-title">TarjetaKpiComparison</h2>
              <h3 class="dash-sub">Tarjeta de comparación entre dos valores con barra proporcional.</h3>
            </div>
          </div>
        </div>

        <div class="col-12">
          <app-tarjeta-kpi-comparison [data]="comparisonData"/>
        </div>

<!-- ──────────── PANEL INSIGHTS ─────────────────────────────────────-->
        <div class="col-12">
          <div class="dash-header" style="margin-bottom: 8px;">
            <div>
              <h2 class="dash-title">PanelInsights</h2>
              <h3 class="dash-sub">Lista vertical de items con <code>headline</code> (coloreado), <code>description</code>
                y
                <code>color</code>. Uso: Decisión Gerencial, Lectura Ejecutiva.
              </h3>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4">
          <app-panel-insights [config]="panelInsights"/>
        </div>
        <div class="col-12 md:col-4">
          <app-panel-insights [config]="panelInsightsGrid"/>
        </div>
  <!-- ─── CHARTS ──────────────────────────────────────────────-->
        <div class="col-12">
          <div class="dash-header" style="margin-bottom: 8px;">
            <div>
              <h1 class="dash-title">Charts</h1>
              <h2 class="dash-sub">Componentes amCharts5. Cada uno incluye su card y canvas propios.</h2>
            </div>
          </div>
        </div>
        <div class="col-12 grid">
          <div class="col-12 md:col-6">
            <div class="dash-card h-full">
              <div class="dash-header">
                <div>
                  <h2 class="dash-title">{{ donutConfig.title }}</h2>
                  @if (donutConfig.sub) {
                    <h3 class="dash-sub">{{ donutConfig.sub }}</h3>
                  }
                </div>
              </div>
              <div class="dash-body">
                <app-chart-donut #donutChart [config]="donutConfig.chart"/>
              </div>
              @if (donutConfig.lastUpdated) {
                <div style="padding:6px 14px 10px;font-size:11px;color:var(--gio-t3)">
                  [Última actualización: {{ donutConfig.lastUpdated.split(',')[0] }},
                  <span class="gio-cyan-color ">{{ donutConfig.lastUpdated.split(',')[1].trim() }}</span>]
                </div>
              }
            </div>
          </div>

          <div class="col-12">
            <div class="dash-card h-full">
              <div class="dash-header">
                <div>
                  <h2 class="dash-title">{{ twoLinkedPieConfig.title }}</h2>
                  @if (twoLinkedPieConfig.sub) {
                    <h3 class="dash-sub">{{ twoLinkedPieConfig.sub }}</h3>
                  }
                </div>
              </div>
              <div class="dash-body">
                <app-chart-two-linked-pie #twoLinkedPieChart [config]="twoLinkedPieConfig.chart"/>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="dash-header" style="margin-bottom: 8px;">
            <div>
              <h2 class="dash-title">ChartLine</h2>
              <h3 class="dash-sub">Implementación del componente app-chart-line.</h3>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6">
          <div class="dash-card h-full">
            <div class="dash-header">
              <div>
                <h2 class="dash-title">{{ lineConfig.title }}</h2>
                @if (lineConfig.sub) {
                  <h3 class="dash-sub">{{ lineConfig.sub }}</h3>
                }
              </div>
            </div>
            <div class="dash-body">
              <app-chart-line #lineChart [config]="lineConfig.chart"/>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6">
          <div class="dash-card h-full">
            <div class="dash-header">
              <div>
                <h2 class="dash-title">{{ linePerSeriesConfig.title }}</h2>
                <h3 class="dash-sub">{{ linePerSeriesConfig.sub }}</h3>
              </div>
            </div>
            <div class="dash-body">
              <app-chart-line #linePerSeriesChart [config]="linePerSeriesConfig.chart"/>
            </div>
          </div>
        </div>

<!--        ─── ChartBar────────────────────────-->
        <div class="col-12">
          <div class="dash-header" style="margin-bottom: 8px;">
            <div>
              <h2 class="dash-title">ChartBar</h2>
              <h3 class="dash-sub">Implementación del componente app-chart-bar.</h3>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="dash-card h-full">
            <div class="dash-header">
              <div>
                <h2 class="dash-title">{{ barColorConfig.title }}</h2>
                @if (barColorConfig.sub) {
                  <h3 class="dash-sub">{{ barColorConfig.sub }}</h3>
                }
              </div>
            </div>
            <div class="dash-body">
              <app-chart-bar #barColorChart [config]="barColorConfig.chart"/>
            </div>
          </div>
        </div>

        <div class="col-12 md:col-6">
          <div class="dash-card h-full">
            <div class="dash-header">
              <div>
                <h2 class="dash-title">{{ barConfig.title }}</h2>
                @if (barConfig.sub) {
                  <h3 class="dash-sub">{{ barConfig.sub }}</h3>
                }
              </div>
            </div>
            <div class="dash-body">
              <app-chart-bar #barChart [config]="barConfig.chart"/>
            </div>
            @if (barConfig.lastUpdated) {
              <div style="padding:6px 14px 10px;font-size:11px;color:var(--gio-t3)">
                [Última actualización: {{ barConfig.lastUpdated.split(',')[0] }},
                <span class="gio-cyan-color ">{{ barConfig.lastUpdated.split(',')[1].trim() }}</span>]
              </div>
            }
          </div>
        </div>

        <div class="col-12">
          <div class="dash-card h-full">
            <div class="dash-header">
              <div>
                <h2 class="dash-title">{{ barGroupedConfig.title }}</h2>
                @if (barGroupedConfig.sub) {
                  <h3 class="dash-sub">{{ barGroupedConfig.sub }}</h3>
                }
              </div>
            </div>
            <div class="dash-body">
              <app-chart-bar #barGroupedChart [config]="barGroupedConfig.chart"/>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="dash-header" style="margin-bottom: 8px;">
            <div>
              <h2 class="dash-title">ChartXY</h2>
              <h3 class="dash-sub">Implementación del componente app-chart-xy.</h3>
            </div>
          </div>
        </div>

        <div class="col-12 grid">
          <div class="col-12 md:col-6">
            <div class="dash-card h-full">
              <div class="dash-header">
                <div>
                  <h2 class="dash-title">{{ xyConfig.title }}</h2>
                  @if (xyConfig.sub) {
                    <h3 class="dash-sub">{{ xyConfig.sub }}</h3>
                  }
                </div>
              </div>
              <div class="dash-body">
                <app-chart-xy #xyChart [config]="xyConfig.chart"/>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="dash-card h-full">
              <div class="dash-header">
                <div>
                  <h2 class="dash-title">{{ xyRawConfig.title }}</h2>
                  @if (xyRawConfig.sub) {
                    <h3 class="dash-sub">{{ xyRawConfig.sub }}</h3>
                  }
                </div>
              </div>
              <div class="dash-body">
                <app-chart-xy #xyRawChart [config]="xyRawConfig.chart"/>
              </div>
            </div>
          </div>
        </div>

        <!-- ─── ChartColumn ────────────────────────────────────────── -->
        <div class="col-12">
          <div class="dash-header" style="margin-bottom: 8px;">
            <div>
              <h2 class="dash-title">ChartColumn</h2>
              <h3 class="dash-sub">Implementación del componente app-chart-column.</h3>
            </div>
          </div>
        </div>

        <div class="col-12 grid">
          <div class="col-12 md:col-4">
            <div class="dash-card h-full">
              <div class="dash-header">
                <div>
                  <h2 class="dash-title">{{ columnConfig.title }}</h2>
                  @if (columnConfig.sub) {
                    <h3 class="dash-sub">{{ columnConfig.sub }}</h3>
                  }
                </div>
              </div>
              <div class="dash-body">
                <app-chart-column #columnChart [config]="columnConfig.chart"/>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4">
            <div class="dash-card h-full">
              <div class="dash-header">
                <div>
                  <h2 class="dash-title">{{ columnEfectividadConfig.title }}</h2>
                  @if (columnEfectividadConfig.sub) {
                    <h3 class="dash-sub">{{ columnEfectividadConfig.sub }}</h3>
                  }
                </div>
              </div>
              <div class="dash-body">
                <app-chart-column #columnEfectividadChart [config]="columnEfectividadConfig.chart"/>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4">
            <div class="dash-card h-full">
              <div class="dash-header">
                <div>
                  <div class="dash-title">{{ columnPerSeriesConfig.title }}</div>
                  <div class="dash-sub">{{ columnPerSeriesConfig.sub }}</div>
                </div>
              </div>
              <div class="dash-body">
                <app-chart-column #columnPerSeriesChart [config]="columnPerSeriesConfig.chart"/>
              </div>
            </div>
          </div>
        </div>

        <!-- ─── ChartRadialGauge ────────────────────────────────────────── -->
        <div class="col-12">
          <div class="dash-header" style="margin-bottom: 8px;">
            <div>
              <h2 class="dash-title">ChartRadialGauge</h2>
              <h3 class="dash-sub">Implementación de <code>am5radar.RadarChart</code> en semicírculo para métricas de avance y porcentajes.</h3>
            </div>
          </div>
        </div>

        <div class="col-12 grid">
          <div class="col-12 md:col-6">
            <div class="dash-card h-full">
              <div class="dash-header">
                <div>
                  <h2 class="dash-title">{{ radialGaugeConfig.title }}</h2>
                  @if (radialGaugeConfig.sub) {
                    <h3 class="dash-sub">{{ radialGaugeConfig.sub }}</h3>
                  }
                </div>
              </div>
              <div class="dash-body">
                <app-chart-radial-gauge #radialGaugeChart [config]="radialGaugeConfig.chart"/>
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6">
            <div class="dash-card h-full">
              <div class="dash-header">
                <div>
                  <h2 class="dash-title">{{ radialGaugeCustomConfig.title }}</h2>
                  @if (radialGaugeCustomConfig.sub) {
                    <h3 class="dash-sub">{{ radialGaugeCustomConfig.sub }}</h3>
                  }
                </div>
              </div>
              <div class="dash-body">
                <app-chart-radial-gauge #radialGaugeCustomChart [config]="radialGaugeCustomConfig.chart"/>
              </div>
            </div>
          </div>
        </div>

<!--          ─── LISTA MÉTRICAS ──────────────────────────────────────── -->
        <div class="col-12">
          <div class="dash-header" style="margin-bottom: 8px;">
            <div>
              <div class="dash-title">Lista Metricas</div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="dash-card h-full">
            <div class="dash-header">
              <div>
                <h2 class="dash-title">{{ listaConfig.title }}</h2>
                @if (listaConfig.sub) {
                  <h3 class="dash-sub" >{{ listaConfig.sub }}</h3>
                }
              </div>
            </div>
             <app-lista-metricas [config]="listaConfig.chart"/>
          </div>
        </div>

      </div>

</div>
